import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as ScanditSDK from "scandit-sdk";
import { Button } from 'reactstrap';
ScanditSDK.configure("AdN99SGJPA5+RD4fsw0+i5QIhIDaNRp3H3FfIuRoO8m2atTLmzLYfe5g0NuffqbR2GcBh68YnaALUxQcX3uQgwRem2t1XRLi/nHHreNXadR4NXgJTDrM/5k7pAet0edIUrI1h9ZG4Av85eTmlzsWxde4gdfawXxiskb5WotFLA6XZPiFCWGl1kD53aynTeF3VPcoc2KFhQRsrJxvCuKQ8SQxs7SSrdAY6wcWqIh3z0RsFg+bvSmiuDS7mqA9FxE7D7luGepSTxOgmYlcdZAAu+k4IH7uXHuwH3nOgpijTHCBVBA0UoRauW+QPvw04Eait3rUx3jgo61vIJpU0zAvy5A/P6vRp96ooMMKOqQVJRu5fEUuLvRj3yw7j+jYPD7XWPAXkf0BlNSsudFgpB4bZBAc/ZmW1ZBzyLzxCswCjzm0O9HP745Wfv8yunzR8aOGpG7j2VncyKyFoSzp6996UPCpEEnoHaSSTt0JXQ50EQy8IhVDQb2BSoft96aBcalHJ8LKMToDrLqsU1VsOX7eo7A5KMislvA0kfCrCxaAMYXhUtr6soV3/TKPet+Jj7HtMnQMuLxbJn+mlP8HSNy8Am2DQR34mB9NPNldk3VRmE4adCHhRHsdH2HcnqPd9ljc6Q6vN4FtWlY9HHd9RfL8+sR+kdY/eyjp8q1S5M7o/RN1Ii2QEp7NE9ujs9OX/gU5VaDE7uIuprfQmBJI4lLIIrzqHq/iJ8jELxnId8EI8QXBVTm3co4B19XKNa60fQOqlCLqLgVmWTqszJ2u0yIf7Kn9p2pf+S64kw==", {
    engineLocation: "scandit-sdk"
  });


export default class BarcodeScanner extends Component {
    state = {
        value: 0,
      };
    scanNow = () => {
        ScanditSDK.BarcodePicker.create(document.getElementById("scandit-barcode-picker"), {
            playSoundOnScan: true,
            vibrateOnScan: true
          }).then(function(barcodePicker) {
            // barcodePicker is ready here to be used (rest of the tutorial code should go here)
            
          var scanSettings = new ScanditSDK.ScanSettings({
            enabledSymbologies: ["ean8", "ean13", "upca", "upce", "code128", "code39", "code93", "itf"],
            codeDuplicateFilter: 1000
          });
          barcodePicker.applyScanSettings(scanSettings);
          barcodePicker.onScan(function(scanResult) {
            alert(scanResult.barcodes.reduce(function(string, barcode) {
              return string + ScanditSDK.Barcode.Symbology.toHumanizedName(barcode.symbology) + ": " + barcode.data + "\n";
            }, ""));
          });
        });

    }
    render(){
        return(
            <div>
                        <Button onClick={() => (this.scanNow())} color="primary">Scan Now</Button>{' '}
                        <div style={{backgroundColor: '#E0E0E0', border: '2px solid #C8C8C8',  borderRadius: 8, marginLeft: '40%', maxWidth: '800px', height: '400px'}}>
                                <div id="scandit-barcode-picker" style={{maxWidth: 790, maxHeight: 390}}></div>
                        </div>
                        
            </div>
        );
    }
  }


// WEBPACK FOOTER //
// ./src/components/BarcodeScanner.js